import React, { useMemo } from 'react';
import cx from 'clsx';

import { IconDefaultBadge, IconDefaultBadgeDark } from '@/assets/badge';
import { LazyMedia } from '@/components';
import { useTheme } from '@/hooks';

import style from './index.module.css';

interface Props {
  className?: string;
  width?: number;
  src?: string;
  onClick?: () => {};
}

// 徽章高宽比
const BADGE_RATIO = 1 / 1;

export const BadgeAvatar = ({ className, width = 32, src, onClick }: Props) => {
  const { isDark } = useTheme();

  const sizeStyle = useMemo(
    () => ({
      width,
      height: BADGE_RATIO * width,
    }),
    [width],
  );

  return (
    <LazyMedia
      className={cx(style.badge, className)}
      style={sizeStyle}
      src={src}
      alt="badge"
      onClick={onClick}
      failedPlaceholder={
        <img src={isDark ? IconDefaultBadgeDark : IconDefaultBadge} alt="badge" style={sizeStyle} />
      }
    />
  );
};
